import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function NotAvailable({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.5078 17.130994c.08-8.97996 7.49866667-16.1964 16.5693333-16.1172 9.0706667.0792 16.3593334 7.42302 16.2793334 16.40364-.08 8.97996-7.498 16.19574-16.5686667 16.11654-9.07133333-.0792-16.36-7.42302-16.28-16.40298zM29.8857333 6.1282L6.70906667 29.0731" />
      </g>
    </svg>
  )
}

NotAvailable.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
